export const YEAR_FORMAT = 'yyyy';

// Month eg: November, 2020
export const MONTH_LONG_YEAR = 'LLLL, yyyy';

export const DATE_MONTH_YEAR = 'dd-MM-yyyy';

export const DAY_OF_MONTH_LONG = 'dd, LLLL yyyy';

export enum TIME_VALUES {
  SECOND = 1000,
  MINUTE = 60 * 1000,
  HOUR = 60 * 60 * 1000,
  HALF_AN_HOUR = 30 * 60 * 1000,
  DAY = 24 * 60 * 60 * 1000,
}
